// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"731":"bff352b4","2533":"bff352b4","3016":"bff352b4","9438":"bff352b4"}[chunkId] + ".chunk.css";
};